<template>
  <v-layout class="preference" align-center>
    <v-flex xs12 sm8 md6 lg4 offset-sm2 offset-md3 offset-lg4 v-if="localUser">
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-card-title>
          <v-layout align-center justify-center>
            <v-avatar v-if="userAvatarUrl" size=128>
              <img :src="userAvatarUrl" class="userLogo">
            </v-avatar>
            <v-icon v-else size=128>person_outline</v-icon>
          </v-layout>
        </v-card-title>
      </v-card>

      <v-form
        ref="form"
        lazy-validation
        >
        <v-card class="mt-3 lists">
          <v-card-title class="text-uppercase subheading">
            <v-avatar size=48>
              <v-icon color="primary" large>settings</v-icon>
            </v-avatar>
            <span class="subheading text-uppercase pl-2">
              General Preferences
            </span>
          </v-card-title>

          <v-card-text>
            <v-select
              v-model="preference.ticket_open_new"
              :items="[{text: 'Open it in a new tab', value: true}, {text: 'Show it in my current tab', value: false}]"
              label="When I create a new ticket...">
            </v-select>
            <v-select
              v-model="preference.page_size"
              :items="[5, 10., 25, 'All']"
              label="How many tickets per page on a list?">
            </v-select>
            <v-select
              v-model="preference.project_id"
              :items="projects.map((pr) => { return pr.attributes })"
              item-text="name"
              item-value="id"
              label="After I log in, take me to...">
            </v-select>
            <v-select
              v-model="preference.watch_weeks"
              :items="[{text: '1 week', value: 1}, {text: '2 weeks', value: 2}, {text: '3 weeks', value: 3}, {text: '4 weeks', value: 4}]"
              label="I want my activity screen to go back...">
            </v-select>
          </v-card-text>
        </v-card>

        <v-card class="mt-3 lists">
          <v-card-title class="text-uppercase subheading">
            <v-avatar size=48>
              <v-icon color="primary" large>view_carousel</v-icon>
            </v-avatar>
            <span class="subheading text-uppercase pl-2">
              Board Preferences
            </span>
          </v-card-title>

          <v-card-text>
            <v-select
              v-model="preference.board_sort_by"
              :items="[{text: 'Due date', value: 'due'}, {text: 'Name', value: 'name'}]"
              label="Sort by">
            </v-select>
            <v-select
              v-model="preference.board_sort_order"
              :items="[{text: 'Ascending', value: 'asc'}, {text: 'Descending', value: 'desc'}]"
              label="Sort direction">
            </v-select>
          </v-card-text>
        </v-card>

        <v-card class="mt-3 lists">
          <v-card-title class="text-uppercase subheading">
            <v-avatar size=48>
              <v-icon color="primary" large>local_play</v-icon>
            </v-avatar>
            <span class="subheading text-uppercase pl-2">
              Ticket Preferences
            </span>
          </v-card-title>

          <v-card-text>
            <v-select
              v-model="preference.ticket_sort_by"
              :items="[{text: 'Number', value: 'sequential_id'}, {text: 'Description', value: 'title'}, {text: 'Status', value: 'status.name'}]"
              label="Sort by">
            </v-select>
            <v-select
              v-model="preference.ticket_sort_order"
              :items="[{text: 'Ascending', value: 'asc'}, {text: 'Descending', value: 'desc'}]"
              label="Sort Direction">
            </v-select>
          </v-card-text>
        </v-card>

        <v-card class="mt-3 lists">
          <v-card-title class="text-uppercase subheading">
            <v-avatar size=48>
              <v-icon color="primary" large>email</v-icon>
            </v-avatar>
            <span class="subheading text-uppercase pl-2">
              Email Preferences
            </span>
          </v-card-title>

          <v-card-text>
            <v-select
              v-model="preference.email_sort_by"
              :items="[{text: 'Received on', value: 'created_at'}, {text: 'Subject line', value: 'subject'}, {text: 'From address', value: 'from'}]"
              label="Sort by">
            </v-select>
            <v-select
              v-model="preference.email_sort_order"
              :items="[{text: 'Ascending', value: 'asc'}, {text: 'Descending', value: 'desc'}]"
              label="Sort Direction">
            </v-select>
          </v-card-text>
        </v-card>

        <v-card class="mt-3 lists">
          <v-card-text>
            <v-alert
              :value="updated"
              color="success"
              icon="check"
              outline
              class="mt-2"
              >
              Preferences updated
            </v-alert>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="updateUser()">Update preferences</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import authentication from '@/utilities/authentication'

  import userService from '@/services/user'
  import projectService from '@/services/project'

  export default {
    name: 'preference-show',

    data () {
      return {
        auth: authentication,
        user: null,
        localUser: null,
        updated: false,
        projects: [],
        preference: {}
      }
    },

    components: {
    },

    watch: {
      preference: {
        handler (val) {
          // hide the updated notice
          this.updated = false
        },
        deep: true
      }
    },

    computed: {
      userAvatarUrl () {
        if (this.user && this.user.links && this.user.links.avatar_large_uri) {
          return (process.env.API_URL + this.user.links.avatar_large_uri)
        }
      },

      sortOrderDescription () {
        if (this.preference.sort_order === 'asc') {
          return 'Sort ascending'
        }
        return 'Sort descending'
      }
    },

    mounted () {
      this.loadUser()
    },

    methods: {
      loadUser () {
        userService.show(
          (data) => {
            this.user = Object.assign({}, data)
            this.localUser = Object.assign({}, data.attributes)
            this.preference = Object.assign({}, data.attributes.preference)
            this.loadProjects()
          },
          (err) => {
            console.log(err)
          },
          this.auth.userId()
        )
      },

      updateUser () {
        if (this.$refs.form.validate()) {
          this.localUser.preference = Object.assign({}, this.preference)
          userService.update(
            (data) => {
              this.auth.instance(data)
              this.updated = true
            },
            (err) => {
              console.log(err)
              this.updated = false
            },
            this.localUser
          )
        }
      },

      loadProjects () {
        projectService.index(
          (data) => {
            data.unshift({attributes: {name: 'My project list', id: null}})
            data.unshift({attributes: {name: 'My activity screen', id: 'activity'}})
            this.projects = data
          },
          (err) => {
            console.log(err)
          }
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-avatar  {
    i {
      border: 2px solid lightgrey !important;
    }
  }

  .lists .v-card__title {
    background-color: #cfcfcf;
  }
</style>



// WEBPACK FOOTER //
// src/components/preference/show.vue